import {useSelector} from 'react-redux';
import {selectIsFuneral, selectType} from '~/common/fabric/reducers/details/selectors';
import {selectClassifiedCategory} from '~/common/fabric/reducers/eviteEvent/selectors';
import {
  BABY_CATEGORY,
  BABY_EVENT_TYPES,
  FUNERAL_CATEGORY,
  WEDDING_CATEGORY,
  WEDDING_EVENT_TYPES,
} from '~/common/utils/event_constants';
import {doesMatchEventCategory, doesMatchEventType} from '~/common/utils/event_utils';

export const useEventGiftingClassifiedCategory = () => {
  const isFuneralType = useSelector(selectIsFuneral);
  const eventType = useSelector(selectType);

  const classifiedCategory = useSelector(selectClassifiedCategory);

  const isFuneralEvent =
    isFuneralType || doesMatchEventCategory(classifiedCategory, FUNERAL_CATEGORY);

  const isWeddingEvent =
    doesMatchEventType(eventType, WEDDING_EVENT_TYPES) ||
    doesMatchEventCategory(classifiedCategory, WEDDING_CATEGORY);

  const isBabyEvent =
    doesMatchEventType(eventType, BABY_EVENT_TYPES) ||
    doesMatchEventCategory(classifiedCategory, BABY_CATEGORY);

  return {isBabyEvent, isFuneralEvent, isWeddingEvent};
};
